import React from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import { FiBell, FiMapPin, FiBriefcase, FiPackage, FiActivity, FiZap, FiCoffee } from 'react-icons/fi';

const ServicesList = () => {
  const { services, selectService, activeTab } = useNotifications();

  // Show empty state if no services
  if (services.length === 0) {
    return (
      <div className="empty-state">
        <FiBell className="empty-icon" />
        <h3 className="empty-title">No Notifications</h3>
        <p className="empty-description">
          {activeTab === 'home'
            ? 'You don\'t have any notifications yet.'
            : activeTab === 'cities'
            ? 'You don\'t have any city notifications.'
            : 'You don\'t have any business notifications.'}
        </p>
      </div>
    );
  }

  const getServiceIcon = (service) => {
    if (service.source === 'city') {
      return <FiMapPin className="service-icon" />;
    }
    
    // Icons for different business service groups
    switch (service.name) {
      case 'Shopping & Delivery':
        return <FiPackage className="service-icon" />;
      case 'Healthcare':
        return <FiActivity className="service-icon" />;
      case 'Utilities':
        return <FiZap className="service-icon" />;
      case 'Dining & Entertainment':
        return <FiCoffee className="service-icon" />;
      default:
        return <FiBriefcase className="service-icon" />;
    }
  };

  const getServiceDisplayName = (service) => {
    return service.displayName || service.name;
  };

  const getServiceStats = (service) => {
    if (service.source === 'city') {
      return `City notifications`;
    } else {
      return `${service.threadsCount} thread${service.threadsCount !== 1 ? 's' : ''}`;
    }
  };

  return (
    <div className="services-list">
      {services.map((service) => (
        <div
          key={service.name}
          className="service-item"
          onClick={() => selectService(service.name)}
        >
          <div className="service-info">
            <div className="service-name">
              {getServiceIcon(service)}
              <span
                className={`service-source-indicator ${
                  service.source === 'city' ? 'city-indicator' : 'business-indicator'
                }`}
              />
              {getServiceDisplayName(service)}
            </div>
            <div className="service-stats">
              {getServiceStats(service)}
            </div>
          </div>
          {service.unreadCount > 0 && (
            <div className="service-badge">{service.unreadCount}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ServicesList;